import { useState } from "react";
import { useAuth, useToast } from "./";
import { NOTIFICATION_TYPES } from "../utils";

export const useExpansionOpportunities = () => {
  const { apiClient } = useAuth();
  const showToast = useToast();
  const [expansionOpportunities, setExpansionOpportunities] = useState([]);

  const fetchExpansionOpportunities = async (customerId) => {
    try {
      const response = await apiClient.get(
        `/accounts/${customerId}/expansion-opportunities/`,
      );
      setExpansionOpportunities(response.data.results);
      return response.data.results;
    } catch (error) {
      console.error("Error fetching expansion opportunities:", error);
      showToast({
        content: "Failed to fetch expansion opportunities",
        type: NOTIFICATION_TYPES.error,
      });
      return [];
    }
  };

  const deleteExpansionOpportunity = async (opportunityId) => {
    try {
      await apiClient.delete(`/expansion-opportunities/${opportunityId}/`);
      showToast({
        content: "Expansion opportunity deleted successfully",
        type: NOTIFICATION_TYPES.success,
      });
      return true;
    } catch (error) {
      console.error("Error deleting expansion opportunity:", error);
      showToast({
        content: "Failed to delete expansion opportunity",
        type: NOTIFICATION_TYPES.error,
      });
      return false;
    }
  };

  return {
    expansionOpportunities,
    setExpansionOpportunities,
    fetchExpansionOpportunities,
    deleteExpansionOpportunity,
  };
};
